export enum PlatformMode {
  Distribution = "Distribution",
  Browser = "Browser",
  Adam = "Adam",
}
